import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import DividendsTable from './components/DividendsTable';
import { usePartnerDividends } from './context/PartnerDividendsContext';

const PartnerDividends: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerDividends();

  return (
    <>
      {data.showTitle && (
        <h6 className="overline-title-alt mb-2">
          {t('DividendsDistribution')}
        </h6>
      )}
      <div className="card card-bordered card-preview">
        <DividendsTable />
      </div>

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default PartnerDividends;
